import { Component } from 'react';
import isEqual from 'lodash/isEqual';

export type Props<A extends unknown[]> = {
	args: A;
	// eslint-disable-next-line jira/react/handler-naming
	op: (...args: A) => void;
};

// eslint-disable-next-line jira/react/no-class-components
class OpTrigger<A extends unknown[]> extends Component<Props<A>> {
	static defaultProps: {
		args: never[];
	} = { args: [] };

	componentDidMount(): void {
		this.props.op(...this.props.args);
	}

	shouldComponentUpdate(nextProps: Props<A>): boolean {
		return !isEqual(this.props.args, nextProps.args);
	}

	componentDidUpdate(): void {
		this.props.op(...this.props.args);
	}

	render() {
		return null;
	}
}

export default OpTrigger;
